var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticClass:"marker-error-vectors",style:(_vm.boxStyle),attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }